import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { asyncConnect } from 'redux-connect';
import { connect } from 'react-redux';
import SelectionTab from '../../components/ZUILib/SelectionTab';
import commonUtil from '../../utils/commonUtil';
import ApplyCSS from '../ApplyCSS';
import * as labelsActions from '../../components/labels/actions';
import { constEventStatus } from '../../utils/clientConstant';

const applicationRoutes = commonUtil.getApplicationRoutes();
const { isLablesLoaded, loadLables } = labelsActions;
const channel = commonUtil.getChannel();
@asyncConnect([{
  promise: ({ store: { dispatch, getState } }) => {
    if (!isLablesLoaded(getState())) {
      return dispatch(loadLables());
    }
    return undefined;
  },
},
])

@connect(store => ({
  lables: store.labels.data,
  error: store.labels.error,
  loading: store.labels.loading,
  user: store.user.data,
  extraData: store.labels.extraData,
}),
  {
    ...labelsActions,
  })

class EventStatusHandler extends Component {
  eventList = (e) => {
    browserHistory.push(commonUtil.getRouteByParameter(applicationRoutes.giftList, { eventID: e.eventId }));
  }
  backToHome = () => {
    browserHistory.push(commonUtil.getRouteByParameter(applicationRoutes.home));
  }
  renderWap() {
    const lables = this.props.lables;
    const eventList = [];
    const eventDetailsList = this.props && this.props.eventDetails && this.props.eventDetails.eventList;
    const possibleEventStatus = [constEventStatus.SUSPENDEDFORTIME, constEventStatus.DELETED, constEventStatus.CLOSED];
    eventDetailsList.forEach((eventData) => {
      if (!possibleEventStatus.includes(eventData.eventStatus)) {
        eventList.push(eventData);
      }
    });
    return (
      <div>
        {(this.props.eventDetails && this.props.eventDetails.eventList && this.props.eventDetails.eventList.length > 1) ?

          <div className="row maxEvents">
            <div className="col-xs-12">
              <h1>{commonUtil.getLabel(lables.eventList, 'eventList.suspendedForTime.warning')}</h1>
              <p>&quot;{commonUtil.getLabel(lables.eventList, 'eventList.suspendedForTime.message')}&quot;</p>
              <SelectionTab
                optionCaption={'Selecciona una opción'}
                id={'eventOptions'}
                options={eventList}
                classname="cSelect"
                optionText="eventName"
                optionValue="eventName"
                value="eventName"
                handleSelectedOption={e => this.eventList(e)}
              />
            </div>
          </div>
          :
          <div className="row maxEvents">
            <div className="col-xs-12">
              <h1>{commonUtil.getLabel(lables.eventList, 'eventList.suspendedForTime.warning')}</h1>
              <p>&quot;{commonUtil.getLabel(lables.eventList, 'eventList.suspendedForTime.message')}&quot;</p>
              <button className="btnPrimary size-Full" onClick={this.backToHome} disabled>Ir a home de mesa de regalos</button>
            </div>
          </div>
        }
      </div>
    );
  }

  renderWeb() {
    const lables = this.props.lables;
    const eventList = [];
    const eventDetailsList = this.props && this.props.eventDetails && this.props.eventDetails.eventList;
    const possibleEventStatus = [constEventStatus.SUSPENDEDFORTIME, constEventStatus.DELETED, constEventStatus.CLOSED];
    eventDetailsList.forEach((eventData) => {
      if (!possibleEventStatus.includes(eventData.eventStatus)) {
        eventList.push(eventData);
      }
    });
    return (
      <div>
        {(this.props.eventDetails && this.props.eventDetails.eventList.length > 1) ?
          // Below code is correct
          <div className="container wrapCLP">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 maxEvent">
                <h1>{commonUtil.getLabel(lables.eventList, 'eventList.suspendedForTime.warning')}</h1>
                <h2>&quot;{commonUtil.getLabel(lables.eventList, 'eventList.suspendedForTime.message')}&quot;</h2>
                <SelectionTab
                  optionCaption={'Selecciona una opción'}
                  id={'eventOptions'}
                  options={eventList}
                  classname="cSelect"
                  optionText="eventName"
                  optionValue="eventName"
                  value="eventName"
                  handleSelectedOption={e => this.eventList(e)}
                />
              </div>
            </div>
          </div>
          :
          // Below code is correct
          <div className="container wrapCLP">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 maxEvent">
                <h1>{commonUtil.getLabel(lables.eventList, 'eventList.suspendedForTime.warning')}</h1>
                <h2>&quot;{commonUtil.getLabel(lables.eventList, 'eventList.suspendedForTime.message')}&quot;</h2>
                <div className="col-sm-12 col-md-12">
                  <button className="btnPrimary size-Large" onClick={this.backToHome} disabled>Ir a home de mesa de regalos</button>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    );
  }
  render() {
    return (
      <div>
        <ApplyCSS pageName="EventsMaxLimitReached" />
        {channel === 'wap' ? this.renderWap() : this.renderWeb()}
      </div>
    );
  }
}
const mapStateToProps = state => ({
  lables: state.labels.data,
  eventDetails: state.eventDetail.data,
});

export default connect(mapStateToProps, undefined)(EventStatusHandler);
